import type { ReactNode } from 'react';

import { cx } from '../lib/cx.ts';

type EmptyStateProps = {
  title: string;
  /** Say what to do next, not that there is nothing here. */
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
};

export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cx(
        'flex flex-col items-center gap-3 rounded-lg border border-dashed border-line',
        'px-6 py-12 text-center',
        className,
      )}
    >
      <h2 className="text-base font-strong text-text">{title}</h2>
      {description === undefined ? null : (
        <p className="max-w-prose text-sm text-muted">{description}</p>
      )}
      {action === undefined ? null : <div className="pt-2">{action}</div>}
    </div>
  );
}
